define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/mouse",
	"dojo/on",
	"dojo/query",
	"underscore"
], function(declare, domClass, mouse, on, query, _) {

	var HIGHLIGHT = "csiHighlight";
	var SELECTED = "csiSelected";

	// Track mouse movement so that highlighting does not occur when content is moved underneath mouse (scrolled) without moving the mouse
	var _mouseMoved = false;

	document.addEventListener('mousemove', function(e) {
		_mouseMoved = true;
	}, {passive: true});

	/**
	 * Toggle CSS class on or off for given node and optional extras
	 * @param {DOMNode} domNode
	 * @param {string} css
	 * @param {boolean} bHighlight
	 * @param {DOMNode[]} [extras]
	 */
	function _toggle(domNode, css, bHighlight, extras) {
		if (domNode) {
			domClass.toggle(domNode, css, bHighlight);
		}

		_.each(extras, function(extraNode) {
			domClass.toggle(extraNode, css, bHighlight);
		});
	}

	return declare(null, {
		// DOMNode: currently highlighted node in view - can only be one refNode, but extras allowed
		//_highlightNode: null,
		//_highlightExtras: null,

		// Boolean: indicates if mouseover highlighting is currently suspended and fixed on single node
		//_bHighlightSuspend: null,

		enableHighlighting: function(/*DOMNode*/node) {
			// summary: add events to node
			on(node, mouse.enter, this._onHighlightOn.bind(this));
			on(node, mouse.leave, this._onHighlightOff.bind(this));
		},

		highlight: function(/*DOMNode*/node, /*Boolean*/bOff, /*Boolean*/bSuspend, /*DOMNode[]?*/extras) {
			// summary: (un)highlight given node
			if (this._bHighlightSuspend && !bSuspend) {
				return;
			}

			// do not highlight ToolbarButton
			if (this.isNewActionsButton(node)) {
				return;
			}

			if (bOff) {
				// remove node highlight
				_toggle(node, HIGHLIGHT, false, extras);

				if (!node || (node == this._highlightNode)) {
					this._highlightNode = null;
				}
			} else if (node != this._highlightNode) {
				// don't allow two nodes to be highlighted at once
				_toggle(this._highlightNode, HIGHLIGHT, false, this._highlightExtras);

				this._highlightNode = node;
				this._highlightExtras = extras;

				_toggle(node, HIGHLIGHT, true, extras);
			}

			// suspend highlighting
			this._bHighlightSuspend = bSuspend && (node == this._highlightNode);
		},

		isSelected: function(/*DOMNode*/node) {
			return node && domClass.contains(node, SELECTED);
		},

		select: function(/*DOMNode*/node, /*Boolean*/b, /*DOMNode[]?*/extras) {
			// summary: add/remove css to node to indicate selection
			// do not select ToolbarButton
			if (!node || this.isNewActionsButton(node)) {
				return;
			}

			_toggle(node, SELECTED, b, extras);
			_mouseMoved = false;
		},

		suspendHighlighting: function() {
			if (this._highlightNode) {
				this.highlight(this._highlightNode, true);
			}

			this._bHighlightSuspend = true;
		},

		getSelectedRows: function(/*DOMNode?*/rootNode) {
			return query("." + SELECTED, rootNode || this.domNode);
		},

		unselectAll: function(/*DOMNode?*/rootNode) {
			// summary: unselect all
			this.getSelectedRows(rootNode).removeClass(SELECTED);
		},

		unsuspendHighlighting: function() {
			this._bHighlightSuspend = false;
		},

		_onHighlightOn: function(/*Event*/e) {
			// summary: onmouseover callback for highlighting
			if (_mouseMoved) {
				this.highlight(e.currentTarget);
				_mouseMoved = false;
			}
		},

		_onHighlightOff: function(/*Event*/e) {
			// summary: onmouseout callback for highlighting
			this.highlight(e.currentTarget, true);
		}
	});
});